import React, { useState, useEffect, useRef } from 'react';
import { uploadFiles, createJob } from '../api/api';
import { callMsGraph } from '../utils/MsGraphApiCall';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { Typography, Box } from '@mui/material';

const CreateJobHandler = ({ setActiveTab }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState('');
  const [userMail, setUserMail] = useState(null);
  const fileInputRef = useRef(null); // Create a ref

  // Fetch signed-in user information
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await callMsGraph();
        setUserMail(userData.mail);
        console.log('User mail:', userData.mail);
      } catch (err) {
        console.error('Error fetching user data:', err);
      }
    };
    fetchUserData();
  }, []);

  // Handle file selection with validation
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      alert('No file selected.');
      return;
    }

    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!['xls', 'xlsx'].includes(fileExtension)) {
      alert('Invalid file type. Please select a valid Excel file.');
      event.target.value = '';
      return;
    }
//can be one or all the five
const reader = new FileReader();
reader.onload = (e) => {
  try {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });

    // Define required and optional sheets
    const requiredSheets = ["Config"];
    const optionalSheets = ["Land", "Energy", "GHG", "Regions", "Mat"];

    // Check if any required sheets are missing
    const missingRequiredSheets = requiredSheets.filter(sheet => !workbook.SheetNames.includes(sheet));

    if (missingRequiredSheets.length > 0) {
      alert(`Missing required sheets: ${missingRequiredSheets.join(', ')}`);
      event.target.value = '';
      return;
    }

    // Check if at least one optional sheet is present
    const hasOptionalSheet = optionalSheets.some(sheet => workbook.SheetNames.includes(sheet));

    if (!hasOptionalSheet) {
      alert(`At least one of the optional sheets (${optionalSheets.join(', ')}) must be present.`);
      event.target.value = '';
      return;
    }

    setSelectedFile(file);
  } catch (error) {
    alert('Invalid Excel file. Please upload a valid Excel document.');
    event.target.value = '';
  }
};
reader.readAsArrayBuffer(file);
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file to upload.');
      return;
    }
    if (!userMail) {
      alert('User email is not available.');
      return;
    }

    try {
      await uploadFiles(selectedFile, userMail);
      await createJob(userMail);
      setMessage('Job created successfully! Please click on View Jobs Tab to see the progress of the created Job');
      setSelectedFile(null);

      // Reset file input using ref
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }

      // Switch tab after successful upload
      setActiveTab('tab3');
    } catch (error) {
      console.error('Error during upload or job creation:', error);
      setMessage('An error occurred. Please try again.');
    }
  };

  // Handle template file download
  const handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = '/input_template.xlsx'; // Ensure the file is in the "public" folder
    link.setAttribute('download', 'input_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container">
          <style>
            {`
             @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
              .home-banner img {
                display: block;
                margin: 0 auto;
              }
              body {
                font-family: 'Roboto';
              }
            `}
        </style>
      <div className="col-12">
      <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
        Follow these steps to create a new job to run the footprint calculation process:
        </h3> 
        <ul>
          <li>Download and open the Excel template by clicking the <strong>Download Input Template</strong> button below.</li>
          <li>Fill in the template with country data. Note that the Footprint Tool will only calculate the indicators for the filled cells in the input template file.</li>
          <li>Save the completed template on your device, then return to the Create Jobs tab of the Tool.</li>
          <li><strong>Upload</strong> the completed template choosing it on your device and clicking the Upload button below. It may take a few seconds for you to receive confirmation that the file has been uploaded. </li>
          <li>You can view the status of the job for the uploaded file in the View Jobs tab.</li>
        </ul>
  
        <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 2 }}>
          Note: 
          <ul>
            <li>The input_template Excel file contains instructions on how to fill it out (steps to follow) and five template sheets for calculating different footprint indicators. </li>
            <li>You can fill in data for one or more footprint indicators for one or more years. Provide as much data as possible, matching the requested rows in the templates for the year(s) you want to calculate.</li>
            <li>Complete the “Config” sheet by entering the country name abbreviation according to the country name table in the Intro sheet of the template.</li>
          </ul>
        </Typography>
  
        <button onClick={handleDownloadTemplate} className="btn btn-primary mt-3">
          Download Input Template
        </button>
      </div>      
      <Box mt={3}>
        <input type="file" ref={fileInputRef} onChange={handleFileChange} className="form-control mb-2" style={{ width: '50%' }} />
        <button onClick={() => {handleUpload()}} disabled={!userMail} className="btn btn-success"> 
          Upload
        </button>
      </Box>
    </div>
  );
};

export default CreateJobHandler;